import { Component, Input, OnDestroy, OnInit, Signal, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CustomerModel } from 'src/app/models/customer-model';
import { isUndefined } from 'src/app/services/codeUtils';
import { Navigator } from "../menu/navigator";
import { LobbyNavigator } from 'src/app/services/lobby/lobby-navigator.service';
import { WebcontentService } from 'src/app/services/webcontent/webcontent.service';
import { LobbyInitService } from 'src/app/services/lobby/lobby-init.service';
import { MobileDataService } from 'src/app/services/mobile-data/mobile-data.service';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '../components.module';
import { JurisdictionService } from 'src/app/services/geo/jurisdiction.service';
import { GeoResponse } from 'src/app/interfaces/geo-interface';
import { WebservicesService } from 'src/app/services/webservices/webservices.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { SearchbarComponent } from '../searchbar/searchbar.component';
import { EventsService } from 'src/app/services/event/event.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-lobby-categories',
  templateUrl: './lobby-categories.component.html',
  styleUrls: ['./lobby-categories.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ComponentsModule,
    SearchbarComponent
  ]
})
export class LobbyCategoriesComponent implements OnInit, OnDestroy {
  @ViewChild('searchPopover') popover;
  @Input() isAuthenticated: boolean;
  @Input() isMobileApp: boolean;
  
  public activeKeyword: string;
  public customer: CustomerModel;
  public keywordsSignal: Signal<any[]>;
  public keywords: any[] = [];
  public lobbyName: any;
  public keyword_route;
  public originalKeywords: any;
  public showSearchButton: boolean = true;
  public searchOpen: boolean = false;
  public tabCasinoClickedSubscription: Subscription;
  private keywordsSubscription: Subscription;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public jursidiction: JurisdictionService,
    private lobbyInit: LobbyInitService,
    private lobbyNavigator: LobbyNavigator,
    private navigator: Navigator,
    private webservicesService: WebservicesService,
    private userSessionService: UserSessionService,
    private webContentService: WebcontentService,
    private mobileData: MobileDataService,
    private eventService: EventsService
  ) { }

  ngOnInit() {
    this.getActiveKeyword();
     this.fetchKeywords();

    if (!this.isMobileApp) {
      this.userSessionService.getUserStatus().subscribe((userStatus) => {
        this.fetchKeywords();
      });
    } else{
      this.subscribeToCasinoTabClick();
      this.fetchKeywords();
      this.mobileData.getActiveMobileKeyword().subscribe((keyword) => {
        if (keyword) {
          this.onSelectKeyword(keyword);
        }
      });
    }

    this.getCustomer();
  }

  private fetchKeywords() {
    this.keywordsSubscription = this.lobbyInit.keywords$.subscribe((currentKeywords) => {
      if (currentKeywords && currentKeywords.length > 0) {
        this.keywords = currentKeywords;     
        if (this.lobbyNavigator.getCasinoDeepLink()) {
          this.checkCasinoDeepLinkKeyword(this.lobbyNavigator.getCasinoDeepLink());
          this.navigator.setActiveLobbyTab('casino');
          this.lobbyNavigator.setCasinoDefaultKeyword(this.keywords[0]);
        } else if (this.lobbyNavigator.getTabDeepLink()) {
          this.checkTabDeepLinkKeyword(this.lobbyNavigator.getTabDeepLink());
          this.lobbyNavigator.setCasinoDefaultKeyword(this.keywords[0]);
        } else if (this.lobbyNavigator.getURLQueryParams()) {
          this.checkQueryParmsForTabSelection(this.lobbyNavigator.getQueryParamsTab())
        } else {
          this.onSelectKeyword(this.keywords[0]);
          this.lobbyNavigator.setCasinoDefaultKeyword(this.keywords[0]);
        }
      }
    });
  }

  private subscribeToCasinoTabClick(): void {
    this.tabCasinoClickedSubscription = this.eventService.subscribe('tab:casino:click', () => {
      console.log('!!! tab:casino:click');
      this.onSelectKeyword(this.keywords[0]);
    });
  }

  private getActiveKeyword(): void {
    this.lobbyNavigator.getKeyword().subscribe(key => {
      this.activeKeyword = key?.name ?? key?.keyword_code;
      if (this.activeKeyword === "FAVOURITE") {
        this.activeKeyword = "Favorites";
      }
    })
  }

  public onSelectKeyword(keyword: any): any {
    this.eventService.publish("event:game:close");
    const actionType = keyword?.action_type;
    const actionParam = keyword?.action_param;
    const code = keyword?.keyword_code;
    if (!this.isMobileApp || this.isAuthenticated) {
      //Handle LiveDealer Case
      const actionParamForGameList: any = actionParam;
      if (!!actionParamForGameList && actionParamForGameList == 'livedealer') {
        this.lobbyNavigator.setKeyword(keyword);
        return this.internalNavAction(keyword, actionParamForGameList);
      }
    }


    switch (actionType) {
      case 'externalpageload':
        this.lobbyNavigator.setKeyword(keyword);
        this.webviewPageLoad(keyword);
        break;
      case 'tab':
        if (code?.toLowerCase()?.includes('sports') && this.isAuthenticated) {
          this.jursidiction.debounceVerifyJurisdiction(() => { }).then((geoResp: GeoResponse) => {
            this.lobbyNavigator.setKeyword(keyword);
            this.navigator.toTab(actionParam);
          });
        } else {
          this.lobbyNavigator.setKeyword(keyword);
          this.navigator.toTab(actionParam);
        }
        break;
      default:
        if (!isUndefined(keyword?.keyword_route)) {
          this.navigator.setSelectedCasinoKeyword(keyword?.keyword_route.toLowerCase())
        } else {
          this.navigator.setSelectedCasinoKeyword('')
        }
        if (!this.isMobileApp) {
          this.navigator.toTab("casino", false, keyword?.keyword_route);
        }
        this.lobbyNavigator.setKeyword(keyword);
        break;
    }
  } 

  private internalNavAction(key: any, nav: any): void {

    switch (nav) {
      case 'livedealer':
        const auth: boolean = this.isAuthenticated;
        this.isAuthenticated ? this.loadLiveDealerAfterGeo() : this.navigator.toLiveDealer();
        break;
      default:
        this.navigator.toCasino();
        break;
    }
  }

  public loadLiveDealerAfterGeo(): any {

    return this.jursidiction.debounceVerifyJurisdiction(() => this.loadLiveDealerAfterGeo()).then((geoResp: GeoResponse) => {
      if (geoResp.is_allowed) {
        this.closeGamesBeforeLiveDealer();
      }
    }).catch(error => {
      console.error("Geo error", error);
      this.navigator.toCasino();
      this.lobbyNavigator.setKeyword(this.lobbyNavigator.getCasinoDefaultKeyword())
    });
  }

  private closeGamesBeforeLiveDealer() {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSessionService.getSessionToken(),
      game_launcher_id: "-1",
    };

    this.webservicesService.post("games/close-game", obj).subscribe({
      next: () => {
        return this.navigator.toLiveDealer()
      }, error: error => {
        this.navigator.toLiveDealer();
      }
    });
  }
  private webviewPageLoad(key: any): any {
    const stub: string = key.action_param;
    this.webContentService.updateExternalLink(stub);
    this.navigator.toTab("c", false, stub);
  }

  checkCasinoDeepLinkKeyword(data) {
    const requiredKey = ["keyword_route"];
    //make the filteredArrayWithKeywordRoute to exclude array items list who don't have 'keyword_route' field
    const filteredArrayWithKeywordRoute = this.keywords.filter(obj => {
      return requiredKey.every(key => Object.keys(obj).includes(key));
    });
    //make hiddenCategoryList array to check deeplinks items as  hidden category will be only accessible through deepLinks
    let filteredArrayWithKeywordRouteForHidden;
    if (this.isMobileApp) {
      filteredArrayWithKeywordRouteForHidden = this.mobileData.getHiddenKeywordListMobile().filter(obj => {
        return requiredKey.every(key => Object.keys(obj).includes(key));
      });
    } else {
      filteredArrayWithKeywordRouteForHidden = this.lobbyNavigator.getHiddenKeywordList().filter(obj => {
        return requiredKey.every(key => Object.keys(obj).includes(key));
      });
    }
    //Check filteredArrayWithKeywordRoute list to validate keyword_route and deeplinks which user tries to launch
    if (filteredArrayWithKeywordRoute && filteredArrayWithKeywordRoute.length > 0) {
      const key_route: any = filteredArrayWithKeywordRoute?.filter((k) => k.keyword_route.toLowerCase() == data.toLowerCase());
      if (key_route && key_route.length > 0) {
        this.isMobileApp ? this.mobileData.setMobileAppCasinoKeywordDeepLink(key_route[0]) : this.onSelectKeyword(key_route[0]);
      } else if (filteredArrayWithKeywordRouteForHidden && filteredArrayWithKeywordRouteForHidden.length > 0) {
        const key_route: any = filteredArrayWithKeywordRouteForHidden?.filter((k) => k.keyword_route.toLowerCase() == data.toLowerCase());
        if (key_route && key_route.length > 0) {
          this.isMobileApp ? this.mobileData.setMobileAppCasinoKeywordDeepLink(key_route[0]) : this.onSelectKeyword(key_route[0]);
        } else {
          this.onSelectKeyword(this.keywords[0]);
        }
      } else {
        this.onSelectKeyword(this.keywords[0]);
      }
    } else {
      this.onSelectKeyword(this.keywords[0]);
    }
  }

  checkTabDeepLinkKeyword(data) {
    const requiredKey = ["action_param"];
   
    const filteredArrayWithActionParam = this.keywords.filter(obj => {
      return requiredKey.every(key => Object.keys(obj).includes(key));
    });
    if (filteredArrayWithActionParam && filteredArrayWithActionParam.length > 0) {
      const action_param_route: any = filteredArrayWithActionParam?.filter((k) => k.action_param.toLowerCase() == data.toLowerCase());
      if (action_param_route && action_param_route.length > 0) {
         this.onSelectKeyword(action_param_route[0]);
         this.navigator.setActiveLobbyTab('casino');
      } else {
        this.onSelectKeyword(this.keywords[0]);
        this.navigator.setActiveLobbyTab('casino');
      }
    } else {
      this.onSelectKeyword(this.keywords[0]);
      this.navigator.setActiveLobbyTab('casino');
    }
  }

  public getCustomer() {
    this.userSessionService.getCustomerSubscription().then((customerSubscription) => {
      customerSubscription.subscribe((customer) => {
        if (customer) {
          this.customer = customer;
        }
      });
    });
  }

  checkQueryParmsForTabSelection(data: string) {
    switch (data) {
        
        case 'casino': {
            const requiredKey = ["keyword_route"];
            const filteredArrayWithKeywordRoute = this.keywords.filter(obj => 
                requiredKey.every(key => Object.keys(obj).includes(key))
            );
            if(this.lobbyNavigator.getQueryParamsTabKeyword()){
              if (filteredArrayWithKeywordRoute.length > 0 || this.lobbyNavigator.getQueryParamsTabKeyword().length > 0) {
                const matchingRoute = filteredArrayWithKeywordRoute.filter(k => 
                    k.keyword_route.toLowerCase() === this.lobbyNavigator.getQueryParamsTabKeyword().toLowerCase()
                );
                if (matchingRoute.length > 0) {
                  
                    this.lobbyNavigator.setKeyword(matchingRoute[0]);
                } else {
                    this.lobbyNavigator.setKeyword(this.keywords[0]);
                }
            } else {
                this.lobbyNavigator.setKeyword(this.keywords[0]);
            }
            } else {
              this.lobbyNavigator.setKeyword(this.keywords[0]);
            }
            
            break;
        }

        case 'c': {
            this.lobbyNavigator.setKeyword(this.keywords[0]);
            break;
        }

        case 'live-dealer': {
          const requiredKey = ["action_param"];
          const filteredArrayWithActionParam = this.keywords.filter(obj => {
            return requiredKey.every(key => Object.keys(obj).includes(key));
          });
          if (filteredArrayWithActionParam && filteredArrayWithActionParam.length > 0) {
            const action_param_route: any = filteredArrayWithActionParam?.filter((k) => k.action_param.toLowerCase() == 'livedealer'.toLowerCase() || k.action_param.toLowerCase() == 'live-dealer'.toLowerCase());
            if (action_param_route && action_param_route.length > 0) {
              this.lobbyNavigator.setKeyword(action_param_route[0]);
            } else {
              this.lobbyNavigator.setKeyword(this.keywords[0]);
            }
          } else {
            this.lobbyNavigator.setKeyword(this.keywords[0]);
          }
          break;
        }

        case 'sports': {  
          const requiredKey = ["action_param"];
          const filteredArrayWithActionParam = this.keywords.filter(obj => {
            return requiredKey.every(key => Object.keys(obj).includes(key));
          });
          if (filteredArrayWithActionParam && filteredArrayWithActionParam.length > 0) {
            const action_param_route: any = filteredArrayWithActionParam?.filter((k) => k.action_param.toLowerCase() == 'sports'.toLowerCase());
            if (action_param_route && action_param_route.length > 0) {
              this.onSelectKeyword(action_param_route[0]);
              this.navigator.setActiveLobbyTab('casino');
            } else {
              this.onSelectKeyword(this.keywords[0]);
              this.lobbyNavigator.setKeyword(this.keywords[0]);
            }
          } else {
            this.onSelectKeyword(this.keywords[0]);
            this.lobbyNavigator.setKeyword(this.keywords[0]);
          }
        
        break;
      }

        default: {
          this.lobbyNavigator.setKeyword(this.keywords[0]);
          break;
        }
    }
}


  showSearchComponent(e: Event) {
    this.popover.event = e;
    this.showSearchButton = false;
    this.searchOpen = true;
  }

  onsearchDismiss() {
    this.searchOpen = false;
    this.showSearchButton = true;
  }

  ngOnDestroy() {
    this.tabCasinoClickedSubscription?.unsubscribe();
    this.keywordsSubscription?.unsubscribe();
  }

  }